require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./winpe-ignite-masterclass-series-01.json") })
        }
      }, "path---winpe-ignite-masterclass-series-01");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---winpe-ignite-masterclass-series-01!./.cache/json/winpe-ignite-masterclass-series-01.json
// module id = 1249
// module chunks = 231608221292675